// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root___x_oq","inputWrap":"CustomTip_inputWrap__1fhel"};